var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 14.8989L15.0087 7.76977C14.9737 7.59199 14.8863 7.44976 14.7638 7.32531C14.5015 7.84088 14.2391 8.35645 14.0292 8.76536L14.8163 12.2677L6.45588 8.24978H9.95396L9.35928 7.07642H2.50305C2.08328 7.07642 1.73347 7.36087 1.62853 7.78755L0.0194116 14.8989C-0.0330596 15.1655 0.0194116 15.45 0.194316 15.6633C0.36922 15.8767 0.614085 16.0011 0.893932 16.0011H15.7433C16.0056 16.0011 16.268 15.8767 16.4429 15.6633C16.6003 15.45 16.6528 15.1655 16.6003 14.8989ZM1.22625 14.8278L2.71293 8.24978H3.72738L6.47337 9.56538L3.70989 14.8278H1.22625ZM5.02167 14.8278L7.52279 10.081L11.4232 11.9477L8.46727 14.8278H5.02167ZM10.1464 14.8278L12.5425 12.4988L15.1486 13.7433L15.3935 14.8278H10.1464Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7205 9.17421C11.8779 9.512 12.3676 9.512 12.5251 9.17421C12.5251 9.17421 14.4315 5.40521 14.8688 4.5163C15.306 3.62738 15.3235 2.6318 14.8688 1.70733C14.0992 0.178391 12.2627 -0.443849 10.741 0.338396C9.21937 1.12064 8.64219 3.0407 9.37679 4.5163C10.1289 5.9919 11.7205 9.17421 11.7205 9.17421ZM12.1228 1.68955C12.9273 1.68955 13.5745 2.34734 13.5745 3.16515C13.5745 3.98295 12.9273 4.64075 12.1228 4.64075C11.3182 4.64075 10.6711 3.98295 10.6711 3.16515C10.6711 2.36512 11.3182 1.68955 12.1228 1.68955Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.58f623bdbf36c62738597e84814ba23c.svg";
export { ForwardRef as ReactComponent };